import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { AgentDetailComponent } from './agent-detail/agent-detail.component';
import { MatDialog } from '@angular/material/dialog';
import { EditAgentComponent } from './edit-agent/edit-agent.component';
import { RefreeListComponent } from '../referee/refree-list/refree-list.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';


export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  serialNumber?: number;
  agentName?: string;
  email?: string;
  phoneNumber?: string;
  agentType?: string;
  assignedLeads?: string;
  status?: string;
  action?: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'active' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'inactive' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];


@Component({
  selector: 'app-agent-list',
  imports: [MaterialModule, CommonModule, RefreeListComponent],
  templateUrl: './agent-list.component.html',
  styleUrl: './agent-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentListComponent {
  displayedColumns: string[] = ['serialNumber', 'agentName', 'email', 'phoneNumber', 'assignedLeads', 'action'];
  dataSource = ELEMENT_DATA;
  tab: any = 'agent'
  // tab: any = 'refree';


  constructor(
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log(this.dataSource)
  }

  changeTab(tab: any) {
    console.log('componeent', tab)
    this.tab = tab;
    // this.cdr.detectChanges();
  }

  edit(data: any) {
    const dialogRef = this.dialog.open(EditAgentComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '70%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  deleteItem(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      panelClass: 'confirm-dialog',
      position: {
        top: '10px', // Align to the top
        // left: '40%', // Center horizontally
      },
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          yes: 'yes',
          no: 'no'
        }
      },
    }).afterClosed().subscribe((result: any) => {
      console.log('Dialog closed with result:', result);
      if (result === true) {
        // Perform delete operation or further logic
      }
    });
  }

  viewDetail(detail: any) {
    const dialogRef = this.dialog.open(AgentDetailComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  approve(element: any) {

  }

  reject(element: any) {

  }


}
